import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";
import ReactMarkdown from "react-markdown";

import { Badge } from "shared/ui/shadcn/badge";
import { CallCopilotCompetitorMessageI } from "@/lib/types/call-copilot/competitor";

import { GitCompareArrowsIcon, BotIcon } from "lucide-react";
import { CallCopilotMessageContainer } from "@/modules/pipeline/account-details/sections/call-copilot-section/message-types/message-container";

export const CallCopilotCompetitorMessage = ({
  competitor,
  competitor_description,
  competitor_handle,
}: CallCopilotCompetitorMessageI) => {
  return (
    <div className="mb-8">
      <CallCopilotMessageContainer>
        <div className="-mt-8 mb-1 flex items-center gap-x-1">
          <Badge className="typography-body-4-medium">
            <GitCompareArrowsIcon className="mr-1 h-4 w-4" /> Competitor
            detected
          </Badge>
        </div>

        <span className="typography-body-4-semibold">{competitor}</span>

        {competitor_description && (
          <ReactMarkdown
            // components={{ p: CustomMarkdownParagraph }}
            className="mb-3 typography-body-4"
            remarkPlugins={[remarkGfm, remarkBreaks]}
          >
            {competitor_description}
          </ReactMarkdown>
        )}
      </CallCopilotMessageContainer>

      <CallCopilotMessageContainer isConnected>
        <div className="-mt-8 mb-2 flex items-center gap-x-1">
          <Badge className="app-gradient-reverse typography-body-4-medium">
            <BotIcon className="mr-1 h-4 w-4" /> Copilot response
          </Badge>
        </div>

        {competitor_handle && (
          <ReactMarkdown
            // components={{ p: CustomMarkdownParagraph }}
            className="text-black typography-body-4"
            remarkPlugins={[remarkGfm, remarkBreaks]}
          >
            {competitor_handle}
          </ReactMarkdown>
        )}
      </CallCopilotMessageContainer>
    </div>
  );
};
